<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid admin-dashboard">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <app-admin-sidebar></app-admin-sidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div :style="{ margin:'80px' }">
                <div class="float-right">
                  <button type="button" class="btn btn-primary" :disabled="isDisabled" @click="exportNPSHistory()">Export<i class="fas fa-spinner fa-spin" v-if="isDisabled"></i></button>
                </div><br>
                <!-- Table Top Start -->
                <div class="d-flex mt-3" style="align-items:center;">
                    <div style="flex-grow:1;" class="pl-2">
                    </div>
                    <div class="form-group form-inline pr-2">
                        <span class="mr-1">Show </span>
                        <select v-model="PageSize" class="form-control">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="50">50</option>
                        </select>
                        <span class="ml-1"> entries</span>
                    </div>
                </div>
                <div class="spinner-border" v-if="showLoader"></div>
                <!-- Table Top End -->
                <!--  Table Start -->
                <table class="table table-hover table-striped mb-2" v-else>
                    <thead>
                    <tr>
                        <th style="width: 10%;">User</th>
                        <th style="width: 10%;">Client</th>
                        <th style="width: 10%;">Value</th>
                        <th style="width: 10%;">Notes</th>
                        <th style="width: 10%;">Quarter</th>
                        <th style="width: 10%;">Quarter Year</th>
                        <th style="width: 10%;">Created On</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="npsData in npsSurveyHistory" :key="npsData.id">
                        <td>{{ npsData.user.username }}</td>
                        <td>{{ npsData.client.name }}</td>
                        <td>{{ npsData.answer }}</td>
                        <td>{{ npsData.notes }}</td>
                        <td>{{ npsData.quarter }}</td>
                        <td>{{ npsData.quarter_year }}</td>
                        <td>{{ npsData.created_at }}</td>
                    </tr>
                    </tbody>
                </table>
                <!--  Table End -->
                <!-- Page Number Start -->
                <div class="d-flex mb-2" style="align-items: center;">
                    <div style="flex-grow: 1;" class="pl-2">
                    <p>
                        Showing {{ (PageNumber - 1) * PageSize + 1 }} to {{ UpperLimit }}
                        of {{ TotalRecords }} entries
                    </p>
                    </div>
                    <div class="pr-2">
                    <Pagination
                    :data="npsSurveyHistory"
                    :totalPages="Math.ceil(TotalRecords / PageSize)"
                    :total="TotalRecords"
                    :perPage="PageSize"
                    :currentPage="PageNumber"
                    @pagechanged="onTablePageChange"
                    />
                    </div>
                </div>
                <!-- Page Number End-->
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardService from "../../services/DashboardService"
import Pagination from "../../components/Pagination.vue";
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: 'BreakageTransactionHistory',
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    Pagination,
  },
  data() {
    return {
        PageSize: 10,
        PageNumber: 1,
        TotalRecords: 0,
        UpperLimit:0,
        npsSurveyHistory:[],
        showLoader: false,
        isDisabled: false,
    }
  },
  methods: {
    getNpsSurveyHistory() {
      this.showLoader = true;
      let data = { pageSize: this.PageSize, page: this.PageNumber }
      DashboardService.getNpsSurveyHistory(data)
        .then((response) => {
          this.showLoader = false;
          this.npsSurveyHistory = response.data.data.data;
          this.TotalRecords = response.data.data.total;
          this.UpperLimit = this.TotalRecords < this.PageNumber * this.PageSize ? this.TotalRecords : this.PageNumber * this.PageSize;
        })
        .catch((e) => {
          this.showLoader = false;
        });
    },
    exportNPSHistory() {
        this.isDisabled =true;
        DashboardService.exportNPSHistory()
          .then((response) => {
            this.isDisabled =false;
            window.location.href = response.data.data;
          })
          .catch((e) => {
            this.isDisabled =false;
            this.$toast.error(e.response.data.respones_msg);
          });
      },
    onTablePageChange(page) {
      this.PageNumber = page;
      try {
        this.getNpsSurveyHistory();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
  },
  watch: {
    PageSize() {
      this.PageNumber = 1;
      this.getNpsSurveyHistory();
    }
  },
  beforeMount() {
    this.getNpsSurveyHistory();
  },
}
</script>
